import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload, X, FileText, Image, File } from 'lucide-react';

function formatBytes(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

function getFileIcon(name) {
  const parts = name.split('.');
  const ext = parts.length > 1 ? parts.pop().toLowerCase() : '';
  if (['jpg','jpeg','png','webp','gif','bmp','tiff','svg','avif'].includes(ext)) return <Image size={20} />;
  if (['pdf','doc','docx','xls','xlsx','ppt','pptx'].includes(ext)) return <FileText size={20} />;
  return <File size={20} />;
}

function getIconBg(name) {
  const parts = name.split('.');
  const ext = parts.length > 1 ? parts.pop().toLowerCase() : '';
  if (ext === 'pdf') return '#E8F1FF';
  if (['jpg','jpeg','png','webp','gif'].includes(ext)) return '#eff6ff';
  if (['doc','docx'].includes(ext)) return '#dbeafe';
  return '#f3f4f6';
}

export default function FileUpload({ onFiles, multiple = false, accept, maxSize = 50 }) {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((accepted) => {
    const newFiles = multiple ? [...files, ...accepted] : accepted;
    setFiles(newFiles);
    onFiles(newFiles);
  }, [files, multiple, onFiles]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple,
    accept: accept || undefined,
    maxSize: maxSize * 1024 * 1024
  });

  const removeFile = (index) => {
    const updated = files.filter((_, i) => i !== index);
    setFiles(updated);
    onFiles(updated);
  };

  return (
    <div>
      <div {...getRootProps()} className={`upload-zone ${isDragActive ? 'active' : ''}`}>
        <input {...getInputProps()} />
        <div className="upload-icon">
          <Upload size={32} />
        </div>
        <h2>Drop your file{multiple ? 's' : ''} here</h2>
        <p>or <strong style={{ color: 'var(--primary)', cursor: 'pointer' }}>browse to upload</strong></p>
        <p className="file-limit">Maximum file size: {maxSize}MB</p>
      </div>

      {files.length > 0 && (
        <div className="file-list">
          {files.map((file, i) => (
            <div className="file-item" key={i}>
              <div className="file-item-icon" style={{ background: getIconBg(file.name), color: '#6b7280' }}>
                {getFileIcon(file.name)}
              </div>
              <div className="file-item-info">
                <div className="name">{file.name}</div>
                <div className="size">{formatBytes(file.size)}</div>
              </div>
              <button className="file-item-remove" onClick={() => removeFile(i)}>
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}